<form [formGroup]="form" *ngIf="!migration; else migrationFlowTemplate">
  <div *ngIf="phoneNumberStep && phoneNumberStep !== 1; else phoneNumberChoice">
    <ng-container [ngSwitch]="phoneNumberStep">
      <div *ngSwitchCase="2">
        <p>
          <strong>
            {{
              'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied/description' | translate
            }}
          </strong>
        </p>
        <p class="warn">
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied/warn' | translate }}
        </p>

        <p
          [innerHTML]="
            'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied/steps' | translate
          "></p>
        <div class="step-actions">
          <button mat-raised-button color="primary" matStepperNext>
            {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied/next' | translate }}
          </button>
          <button mat-raised-button (click)="backToChoices()">
            {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied/back' | translate }}
          </button>
        </div>
      </div>
      <div *ngSwitchCase="3">
        <p>
          <strong>
            {{
              'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-not-reachable/description'
                | translate
            }}
          </strong>
        </p>
        <p class="step-description-link">
          <a
            href="https://developers.facebook.com/docs/whatsapp/cloud-api/phone-numbers/"
            rel="noopener noreferrer"
            target="_blank">
            {{
              'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-not-reachable/link'
                | translate
            }}&nbsp;<mat-icon>open_in_new</mat-icon>
          </a>
        </p>
        <div>
          <button mat-raised-button color="primary" (click)="backToChoices()">
            {{ 'back' | translate }}
          </button>
        </div>
      </div>
      <div *ngSwitchCase="4">
        <p>
          <strong>
            {{
              'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/no-phone-number/description' | translate
            }}
          </strong>
        </p>
        <p class="step-description-link">
          <a
            href="https://developers.facebook.com/docs/whatsapp/cloud-api/phone-numbers/"
            rel="noopener noreferrer"
            target="_blank">
            {{
              'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/no-phone-number/link' | translate
            }}&nbsp;<mat-icon>open_in_new</mat-icon>
          </a>
        </p>
        <div>
          <button mat-raised-button color="primary" (click)="backToChoices()">
            {{ 'back' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-template #phoneNumberChoice>
    <mat-radio-group formControlName="phoneNumberStep">
      <mat-radio-button [value]="1">
        <p>
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-not-tied' | translate }}
        </p>
        <p class="description">
          {{
            'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-not-tied-description'
              | translate
          }}
        </p>
      </mat-radio-button>
      <mat-radio-button [value]="2">
        <p>
          {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied' | translate }}
        </p>
        <p class="description">
          {{
            'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-tied-description' | translate
          }}
        </p>
      </mat-radio-button>
      <mat-radio-button [value]="3">
        {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/phone-number-not-reachable' | translate }}
      </mat-radio-button>
      <mat-radio-button [value]="4">
        {{ 'add-account/whatsapp-cloud-api/pre-qualify/steps/phone-number/no-phone-number' | translate }}
      </mat-radio-button>
    </mat-radio-group>
    <div class="step-actions">
      <button mat-raised-button color="primary" (click)="tryToNext()">{{ 'next' | translate }}</button>
    </div>
  </ng-template>
</form>

<ng-template #migrationFlowTemplate>
  <form [formGroup]="$any(form.get('migrate'))">
    <mat-checkbox [disableRipple]="true" formControlName="agreed">
      <strong translate="add-account/whatsapp-cloud-api/migrate/steps/phone-number/verification/title"></strong>
    </mat-checkbox>
    <ul class="verifications">
      <li
        [innerHTML]="
          'add-account/whatsapp-cloud-api/migrate/steps/phone-number/verification/verification-1' | translate
        "></li>
      <li
        [innerHTML]="
          'add-account/whatsapp-cloud-api/migrate/steps/phone-number/verification/verification-2' | translate
        "></li>
      <li
        [innerHTML]="
          'add-account/whatsapp-cloud-api/migrate/steps/phone-number/verification/verification-3' | translate
        "></li>
      <li
        [innerHTML]="
          'add-account/whatsapp-cloud-api/migrate/steps/phone-number/verification/verification-4' | translate
        "></li>
    </ul>

    <div class="step-actions">
      <button mat-raised-button color="primary" [disabled]="form.get('migrate').invalid" (click)="tryToNext()">
        {{ 'next' | translate }}
      </button>
    </div>
  </form>
</ng-template>
